import { render, staticRenderFns } from "./dictionaryList.vue?vue&type=template&id=6092f8a6&scoped=true"
import script from "./dictionary?vue&type=script&lang=js&external"
export * from "./dictionary?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6092f8a6",
  null
  
)

export default component.exports